var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 57,
    viewBox: "0 0 78 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0444 48.7015C23.3641 48.9172 23.688 49.5738 23.7878 50.0423C23.8847 50.4975 23.6096 51.2348 23.5308 51.4458L23.5244 51.463C22.0604 55.3994 17.1417 56.007 15.544 53.7268C15.4756 53.6292 15.2736 53.4555 15.2185 53.3702C-4.21154 32.4896 13.558 9.36479 26.4377 1.82073C2.082 21.6802 12.8897 41.8472 23.0444 48.7015Z",
    fill: "url(#paint0_linear_1301_3343)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3952 9.95373C47.0433 9.79595 46.5364 8.95729 46.4491 8.45157C46.3618 7.94585 46.4131 7.50914 46.4491 7.31533C47.2168 3.18629 51.9586 1.74472 53.9234 3.71739C54.0075 3.80184 54.0852 3.85523 54.1541 3.92976C76.8752 21.1715 63.4828 47.0827 52.0866 56.7224C72.6784 32.9827 58.5744 14.9663 47.3952 9.95373Z",
    fill: "url(#paint1_linear_1301_3343)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1301_3343",
    x1: 23.7461,
    y1: 0.679735,
    x2: 12.2077,
    y2: 62.6401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA601",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ECA601",
    stopOpacity: 0.740074
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECA601"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1301_3343",
    x1: 54.9338,
    y1: 57.3852,
    x2: 55.6827,
    y2: -5.63581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F78E0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3F78E0",
    stopOpacity: 0.740074
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F78E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.8906281150cac15354e559ba8cca48c9.svg";
export { ForwardRef as ReactComponent };